import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDropside(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="m16 12-6-5v10l6-5Z" fill="currentColor" />
    </BaseIcon>
  );
}
